<div mat-dialog-title>
  <h1>Add <span class="highlight">{{ data.masterFile }}</span> to release</h1>
  <small>
    Every home with the <strong>{{ data.masterFile }}</strong> master file<span *ngIf="data.options.length > 0">, with options <strong>{{ data.options.join(', ') }}</strong> where the home has them</span>.
    Untick any homes you don't want, then pick the style templates and releases.
  </small>
</div>
<mat-dialog-content>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="m-b-10">
    <strong>{{ selectedCount }} of {{ data.matches.length }} homes selected</strong>
    <div fxLayout="row" fxLayoutGap="8px">
      <button mat-button (click)="setAll(true)">Select all</button>
      <button mat-button (click)="setAll(false)">Select none</button>
    </div>
  </div>
  <div *ngFor="let match of data.matches" class="facade-home-row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <mat-checkbox [checked]="match.selected" (change)="toggle(match)">
      {{ match.homeName }}
    </mat-checkbox>
    <small *ngIf="match.isCurrentHome" class="text-success">current</small>
    <small *ngIf="match.isPlaceholder" matTooltip="This home's master file is a placeholder copy">placeholder</small>
    <small *ngIf="match.missingOptions.length > 0" class="text-warning"
      matTooltip="This home doesn't have these options, so they won't be included">
      without {{ match.missingOptions.join(', ') }}
    </small>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="accent" [disabled]="selectedCount < 1" (click)="confirm()">
    Next: choose style templates
  </button>
</mat-dialog-actions>
